<template>


    <div class="container bootstrap snippets bootdey">
        <div class="row mt-4">
            <div class="col">
                <h2>
                    <strong>Pengumuman</strong>
                </h2>
            </div>
            <div class="col">
                <router-link to="/Pengumuman" class="btn btn-success float-end">
                    <i class="bi bi-eye"></i> Lihat Semua
                </router-link>
            </div>
        </div>
        <hr>

        <div class="row">

            <div v-if="newsList.length" class="row mb-4">
                <div v-for="news in newsList" :key="news.id" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="well blog">
                        <router-link :to="`/pengumuman/${news.id}`">
                            <div class="date primary">
                                <span class="blog-date">{{ getFormattedMonthWithDayjs(news.created_at) }}</span>
                                <!-- <span class="blog-number">{{ String(news.created_at).padStart(2, '0')}}</span> -->
                            </div>
                            <div class="row">
                                <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8">
                                    <div class="image">
                                        <img :src="`http://bkpsdm.kendalkab.go.id/bahurekso/packages/photo/${news.fav}`"
                                            alt="..." />
                                        <!-- <img src="https://www.bootdey.com/image/800x300/6495ED/000000" alt=""> -->
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                    <div class="blog-details">

                                        <h2>{{ news.titel }}</h2>
                                        <p>
                                            {{ news.desc }}
                                        </p>
                                        <!-- <router-link class="btn btn-success">Baca Selengkapnya</router-link> -->
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
import axios from "axios";
import dayjs from 'dayjs';

export default {
    name: "PengumumanComponent",
    data() {
        return {
            newsList: [],
            loading: true,
            error: null,
        };
    },

    methods: {

        getFormattedMonthWithDayjs(dateStringFromApi) {
            return dayjs(dateStringFromApi).format('MMM');
        },
        getFormattedDateWithDayjs(dateStringFromApi) {
            return dayjs(dateStringFromApi).format('dd');
        },
        async fetchNews() {
            try {
                const response = await axios.get(
                    "/content/pengumuman?pages=1&limit=3"
                );
                console.log(response.data); // Cek struktur API

                if (Array.isArray(response.data.data)) {
                    this.newsList = response.data.data;
                } else {
                    console.error("Data tidak berbentuk array:", response.data);
                    this.error = "Format data tidak valid";
                }
            } catch (err) {
                this.error = "Gagal memuat berita. Coba lagi nanti.";
            } finally {
                this.loading = false;
            }
        },
        formatDate(date) {
            const options = { year: "numeric", month: "long", day: "numeric" };
            return new Date(date).toLocaleDateString("id-ID", options);
        },
    },
    created() {
        this.fetchNews();
    },
};
</script>

<style>
body {
    background: #eee;
}

p {
    font-size: 14px;
    color: #777;
}

.blog .image {
    height: 250px;
    overflow: hidden;
    border-radius: 3px 0 0 3px;
}

.blog .image img {
    width: 100%;
    height: auto;
}

.blog .date {
    top: -10px;
    z-index: 99;
    width: 65px;
    right: -10px;
    height: 65px;
    padding: 10px;
    position: absolute;
    color: #FFFFFF;
    font-weight: bold;
    background: #5bc0de;
    border-radius: 999px;
}

.blog .blog-details {
    padding: 0 20px 0 0;
}

.blog {
    padding: 0;
}

.well {
    border: 0;
    padding: 20px;
    min-height: 63px;
    background: #fff;
    box-shadow: none;
    border-radius: 3px;
    position: relative;
    max-height: 100000px;
    border-bottom: 2px solid #ccc;
}

.blog .blog-details h2 {
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.blog .date .blog-number {
    color: #fff;
    display: block;
    font-size: 24px;
    text-align: center;
}
</style>